export { AtnDsNoticeIconComponent as Component } from './icon.component'
